module.exports = __webpack_public_path__ + "static/media/404.41b647e2.svg";